var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfident(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 16.5C33 25.6116 25.6154 33 16.5 33C7.3884 33 0 25.6154 0 16.5C0 7.3884 7.3884 0 16.5 0C25.6116 0 33 7.3884 33 16.5Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1488 15.3264C27.1488 16.5044 26.1919 17.4613 25.0138 17.4613C23.8358 17.4613 22.8789 16.5044 22.8789 15.3264C22.8789 14.1483 23.8358 13.1914 25.0138 13.1914C26.1957 13.1876 27.1488 14.1445 27.1488 15.3264Z",
    fill: "#562912"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.213 13.2079C22.1444 13.2079 22.072 13.1927 22.0034 13.166C21.7327 13.0516 21.6031 12.739 21.7174 12.4683C21.7594 12.373 22.7353 10.1008 26.1741 10.7489C26.4638 10.8023 26.6583 11.0844 26.6049 11.378C26.5515 11.6715 26.2694 11.8621 25.9759 11.8088C23.4292 11.3284 22.7391 12.8229 22.7125 12.8877C22.621 13.0859 22.4227 13.2079 22.213 13.2079Z",
    fill: "#562912"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4769 15.3264C10.4769 16.5044 9.51998 17.4613 8.34196 17.4613C7.16393 17.4613 6.20703 16.5044 6.20703 15.3264C6.20703 14.1483 7.16393 13.1914 8.34196 13.1914C9.51998 13.1876 10.4769 14.1445 10.4769 15.3264Z",
    fill: "#562912"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54507 13.8279C5.47645 13.8279 5.40401 13.8127 5.33538 13.786C5.06471 13.6716 4.93508 13.3628 5.04946 13.0883C5.09139 12.993 6.07118 10.7246 9.50613 11.3689C9.79588 11.4223 9.99031 11.7044 9.93694 11.998C9.88356 12.2915 9.60145 12.4821 9.30789 12.4288C6.76122 11.9484 6.07118 13.4429 6.04449 13.5077C5.953 13.7059 5.75094 13.8279 5.54507 13.8279Z",
    fill: "#562912"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2751 27.019C17.8519 27.019 17.4973 26.6911 17.4707 26.2641C17.4402 25.8181 17.7795 25.4369 18.2255 25.4064C20.5587 25.2577 22.8156 24.0682 24.2605 22.223C24.535 21.8723 25.0421 21.8113 25.3928 22.0858C25.7435 22.3603 25.8045 22.8673 25.53 23.2181C23.8068 25.4178 21.1153 26.836 18.3284 27.0152C18.3094 27.019 18.2941 27.019 18.2751 27.019Z",
    fill: "#562912"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfident);
export default __webpack_public_path__ + "static/media/confident.9c7a488ab793c81ce82c7a61644cab38.svg";
export { ForwardRef as ReactComponent };